export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/35a9c0e3cc29-tooliconmoney.jpg',
  },
  title: 'Total paid for',
}
